export default __webpack_public_path__ + "static/media/svg3.abac5156.svg";